<template>
  <div id="app">
    <div v-if="loading" class="spinner-container">
      <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
    </div>
    <Header />
    <div class="container mt-3">
      <div class="row">
        <div class="col">
          <Search v-bind:searchData="groupData" v-on:scrollto="scrollToGroupList" />
        </div>
      </div>
    </div>
    
    <Map v-bind:mapData="groupData" />

    <div class="container pt-5">
      <a name="grouplist" ref="grouplist"></a>
      <GroupList v-bind:groupData="groupData" />
    </div>

    <Footer />
  </div>
</template>

<script>
import Search from './components/Search.vue'
import Map from './components/Map.vue'
import GroupList from './components/GroupList.vue'
import groups from './groups.js'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Search,
    Map,
    GroupList,
    Header,
    Footer
  },
  data: function() {
    return {
      groupData: [],
      loading: true
    }
  },
  methods: {
    scrollToGroupList() {
      var element = this.$refs['grouplist'];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  },
  created() {
    document.title = "Journey Groups | Grand Rapids Baptist Church"
    groups.getGroups().then((response) => {
      this.groupData = response
      this.$root.$emit('filter-search-complete', this.groupData)
      this.$root.$emit('hide-spinner')
    })
  },
  mounted() {
    this.$root.$on('show-spinner', () => {
      this.loading = true
    });
    this.$root.$on('hide-spinner', () => {
      this.loading = false
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#group-list img {
  height: 100%;
  object-fit: cover;
}
.spinner-container:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
}
.spinner-container {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
